import { cn } from "@vaporfi/utils";
import { getCustomMeta, getDefaultMetaData } from "config/constants/meta";
import Head from "next/head";
import { useRouter } from "next/router";
import Container from "./Container";

export const PageMeta: React.FC<
	React.PropsWithChildren<{ symbol?: string }>
> = ({ symbol }) => {
	const { pathname } = useRouter();

	const pageMeta = getCustomMeta(pathname) || {};
	const { description, image, title } = {
		...getDefaultMetaData(),
		...pageMeta,
	};
	let pageTitle = title;
	if (symbol) {
		pageTitle = [symbol, title].join(" - ");
	}

	return (
		<Head>
			<title>{pageTitle}</title>
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:image" content={image} />
		</Head>
	);
};

interface PageProps extends React.HTMLAttributes<HTMLDivElement> {
	symbol?: string;
}

const Page = ({ children, symbol, className, ...props }: PageProps) => {
	return (
		<>
			<PageMeta symbol={symbol} />
			<Container
				className={cn(
					"min-h-[calc(100vh-164px)] sm:min-h-[calc(100vh-64px)] py-4 sm:py-6 lg:py-8",
					className,
				)}
				{...props}
			>
				{children}
			</Container>
		</>
	);
};

export default Page;
